var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / iconoir / profile-circled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.5 7C23.17 7 7.5 22.67 7.5 42C7.5 61.3298 23.17 77 42.5 77C61.8298 77 77.5 61.3298 77.5 42C77.5 22.67 61.8298 7 42.5 7Z",
    stroke: "#21272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4482 64.2099C15.4482 64.2099 23.2498 54.25 42.4997 54.25C61.7497 54.25 69.5516 64.2099 69.5516 64.2099",
    stroke: "#21272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.5 42C48.2992 42 53 37.2992 53 31.5C53 25.701 48.2992 21 42.5 21C36.7008 21 32 25.701 32 31.5C32 37.2992 36.7008 42 42.5 42Z",
    stroke: "#21272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircled);
export default __webpack_public_path__ + "static/media/profileCircled.c4a3f50e97a8004ec5823225a89a075a.svg";
export { ForwardRef as ReactComponent };